import { Chip } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
import { TFunction } from 'react-i18next';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useTranslation } from 'react-i18next';
import { useTransactionStatuses } from '../contexts/Parameters/hooks';
import { TransactionStatus } from '../domain/Transaction/entities/TransactionStatus';

export interface TransactionStatusChipProps {
  id: number;
}

export const getTransactionStatus: (
  id: number,
  transactionStatuses: Nullable<TransactionStatus[]> | undefined,
  t: TFunction,
) => {
  value: string;
  color: 'default' | 'success' | 'info' | 'error' | 'warning';
} = (id, transactionStatuses, t) => {
  switch (id) {
    case -1:
      return { value: t('status.negative1'), color: 'default' };
    case 1:
      return { value: t('status.1'), color: 'warning' };
    case 3:
      return { value: t('status.3'), color: 'warning' };
    case 5:
      return { value: t('status.5'), color: 'success' };
    case 6:
      return { value: t('status.6'), color: 'success' };
    case 9:
      return { value: t('status.9'), color: 'error' };
    case 10:
      return { value: t('status.10'), color: 'error' };
    case 13:
      return { value: t('status.13'), color: 'success' };
    default:
      return {
        value:
          transactionStatuses?.find(transactionStatus => transactionStatus.id === id)?.description ??
          t('orderStatus.0'),
        color: 'default',
      };
  }
};
const TransactionStatusChip: FC<TransactionStatusChipProps> = ({ id }) => {
  const { t } = useTranslation();
  const transactionStatuses = useTransactionStatuses();
  return (
    <Chip
      label={getTransactionStatus(id, transactionStatuses, t).value}
      bgColor={getTransactionStatus(id, transactionStatuses, t).color}
    />
  );
};

export { TransactionStatusChip };
